"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tracker = void 0;
const mixpanel_browser_1 = __importDefault(require("mixpanel-browser"));
class Tracker {
    constructor({ user, account, universe, peopleData, config }) {
        var _a;
        if (!(config === null || config === void 0 ? void 0 : config.token)) {
            throw Error('Token not found in configuration');
        }
        const instanceName = (_a = config === null || config === void 0 ? void 0 : config.name) !== null && _a !== void 0 ? _a : `${Date.now()}`;
        this.instance = mixpanel_browser_1.default.init(config.token, Object.assign({}, config === null || config === void 0 ? void 0 : config.extra), instanceName);
        if (user === null || user === void 0 ? void 0 : user.id) {
            this.instance.identify(user.id);
        }
        if (peopleData) {
            this.instance.people.set(Object.assign(Object.assign({}, peopleData), { email: user === null || user === void 0 ? void 0 : user.email }));
        }
        this.instance.register({
            accountId: account === null || account === void 0 ? void 0 : account.id,
            accountName: account === null || account === void 0 ? void 0 : account.name,
            universeId: universe === null || universe === void 0 ? void 0 : universe.id,
            universeName: universe === null || universe === void 0 ? void 0 : universe.name,
        });
    }
    track(eventName, metadata) {
        return __awaiter(this, void 0, void 0, function* () {
            this.instance.track(eventName, metadata);
        });
    }
    timerFor(eventName) {
        return __awaiter(this, void 0, void 0, function* () {
            this.instance.time_event(eventName);
        });
    }
    mixpanelInstace() {
        return this.instance;
    }
}
exports.Tracker = Tracker;
